import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useLocation, } from 'react-router-dom';
import AddFaqs from './components/AddFaqs';
import { faqsLisitingRequest, deleteFaqs } from '../faqs/redux/faqsDispatcher';


function FaqsListingTable({ faqsListing }) {

  const paginationModel = { page: 0, pageSize: 10 };

  const dispatch = useDispatch();
  const location = useLocation();

  const faqsListingHeading = [

    {
      field: "id", headerName: "NO", width: 40,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: "updated_at", headerName: "DateTime", width: 200,
    },

    {
      field: "question", headerName: "Question", width: 200,
    },

    {
      field: "answer",
      headerName: "Answer",
      width: 300,
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{ __html: params.value }}
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" }}
        />
      ),
    },

    {
      field: "action",
      headerName: "Action",
      width: "auto",
      sortable: false,
      renderCell: (params, row) => {
        console.log("veiw is called", params, row);


        return (
          <div style={{
            display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
            height: "100%"
          }}>
            <AddFaqs
              buttonLabel="Edit"
              editMode={true}
              faqsData={params.row}
            />


            <button
              onClick={() => handleDelete(params.row)}
              style={{
                backgroundColor: "#F44336",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "10px",
                width: "30%",
                height: "24px",  // Increased height
                padding: "2px 30px", // Added padding
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Delete
            </button>


          </div>

        );
      },
    },


  ];


  const handleDelete = (row) => {
    console.log("Deleting Question ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete question "${row.question}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteFaqs(row.id,));
      }
    });

    // Add your delete logic here
  };


  React.useEffect(() => {

    dispatch(faqsLisitingRequest());
  }, [dispatch, location.pathname]);

  return (

    <Paper sx={{ height: "95%", width: '100%' }}>


      <div style={{ padding: "10px", justifyItems: "end" }}>
        <AddFaqs buttonLabel={"Add FAQ"}
        />
      </div>










      <DataGrid
        rows={faqsListing.faqsListing || []}
        columns={faqsListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading={faqsListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}


      />
    </Paper>
  );
}




//Getting the state from the store
const mapStateToProps = (state) => {
  console.log(
    "PERMISSSION:::::::::"
    , state.faqsReducer);
  return {
    faqsListing: state.faqsReducer, // Add optional chaining
  };
};



//passing the faqs Data  in fetchFaqs function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    faqsLisitingRequest: () => dispatch({ "type": "GET_FAQS_REQUEST" }), // Corrected function name
  };
};




//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(FaqsListingTable);
